<template>
  <div class="relative h-[298px] bg-[#fff] rounded-[16px]" v-if="props.quoteSnapData" @click="emit('stock-click')">
    <QuoteSnapshot
      :data-source="quoteSnapshotProps.dataSource"
      :language="quoteSnapshotProps.language"
      :up-down-color="quoteSnapshotProps.upDownColor"
      :watch-visible="quoteSnapshotProps.watchVisible"
      :skin="quoteSnapshotProps.skin"
      :quote-minute-color="quoteSnapshotProps.quoteMinuteColor"
      :load-status="true"
    />

    <!-- 收藏图标 -->
    <img
      :src="favorited ? iconFavoritedUrl : iconFavoriteUrl"
      class="absolute top-[24px] right-[34px] h-[40px] w-[40px] cursor-pointer"
      @click.stop="handleToggleWatch"
    />
  </div>
</template>

<script lang="ts">
import QuoteSnapshot from '@futuweb/quote-chart-ui/lib/v2/QuoteSnapshot/index.js';
import '@futuweb/quote-chart-ui/lib/v2/QuoteSnapshot/index.css';
import { computed } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  favorited: {
    key: "favorited",
    required: false,
    type: Boolean
  },
  quoteSnapData: {
    key: "quoteSnapData",
    required: false,
    type: [Object, null]
  },
  upDownType: {
    key: "upDownType",
    required: false,
    type: Number
  },
  lang: {
    key: "lang",
    required: false,
    type: Number
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const iconFavoriteUrl = require('../images/icon-like.png');
  const iconFavoritedUrl = require('../images/icon-liked.png');
  const props = __props;
  const emit = __ctx.emit;
  const quoteSnapshotProps = computed(() => {
    return {
      language: props.lang,
      upDownColor: props.upDownType ?? 0,
      watchVisble: false,
      skin: 'white',
      dataSource: props.quoteSnapData ? props.quoteSnapData : {},
      quoteMinuteColor: 1
    };
  });
  function handleToggleWatch() {
    if (props.favorited) {
      emit('remove-watch');
    } else {
      emit('add-watch');
    }
  }
  return {
    iconFavoriteUrl,
    iconFavoritedUrl,
    props,
    emit,
    quoteSnapshotProps,
    handleToggleWatch
  };
};
__sfc_main.components = Object.assign({
  QuoteSnapshot
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped>
.quote-snapshot-card {
  /* width: 100% !important; */
  max-width: 50%;
  background: #fff;
  transform: scale(2);
  transform-origin: top left;

  .price-info {
    svg {
      width: .12rem;
      height: .12rem;
    }
  }
}
</style>
